import * as React from "react";
const SvgBillOfMaterials20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5 1h13v15a3 3 0 0 1-3 3H4.5A2.5 2.5 0 0 1 2 16.5V12h3V1Zm0 13H4v2.5a.5.5 0 0 0 1 0V14Zm1.95 3H15a1 1 0 0 0 1-1V3H7v13.5c0 .171-.017.338-.05.5ZM14 7H9V5h5v2Zm-5 4h5V9H9v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgBillOfMaterials20Px;
